<template>
  <header class="ml-2 mr-2 mt-1">
    <nav
      role="navigation"
      aria-label="main navigation"
      class="is-flex is-justify-content-space-between is-align-items-center"
    >
      <router-link to="/">
        <img
          alt="Bingo Bango logo"
          src="../assets/logo-words.svg"
          style="height: 3rem"
        />
      </router-link>
      <router-link to="/">
        <span class="icon"><font-awesome-icon icon="arrow-left"/></span>
      </router-link>
    </nav>
  </header>

  <section class="section pb-1 pt-1">
    <div class="container">
      <div class="buttons m-0 is-flex is-justify-content-center">
        <button
          class="button is-ghost is-small mb-0"
          @click="speak('Eyes down')"
        >
          <span class="icon has-text-info">
            <font-awesome-icon icon="glasses" />
          </span>
        </button>
        <button class="button is-ghost is-small mb-0" @click="speak('Line!')">
          <span class="icon has-text-info">
            <font-awesome-icon icon="grip-lines" />
          </span>
        </button>
        <button class="button is-ghost is-small mb-0" @click="speak('House!')">
          <span class="icon has-text-info">
            <font-awesome-icon icon="home" />
          </span>
        </button>
        <button class="button is-ghost is-small mb-0" @click="speak('Nope')">
          <span class="icon has-text-info">
            <font-awesome-icon icon="times-circle" />
          </span>
        </button>
        <button
          class="button is-ghost is-small mb-0"
          @click="speak('Shh. Be quiet.')"
        >
          <span class="icon has-text-info">
            <font-awesome-icon icon="comment-slash" />
          </span>
        </button>
        <button class="button is-ghost is-small mb-0" @click="speak('Bingo!')">
          <span class="icon has-text-info">
            <font-awesome-icon icon="bullhorn" />
          </span>
        </button>
        <button
          class="button is-ghost is-small mb-0"
          @click="speak('Stop farting')"
        >
          <span class="icon has-text-info">
            <font-awesome-icon icon="wind" />
          </span>
        </button>
      </div>
      <div class="is-flex is-justify-content-center is-align-items-center">
        <div class="m-2 pt-1 history-box">
          <History :history="history" />
        </div>
        <div>
          <button
            class="button is-outlined is-medium is-danger current-number"
            @click="handleRecallCurrentNumber"
          >
            <span v-if="currentNumber">
              {{ currentNumber.value }}
            </span>
            <span v-else>
              -
            </span>
          </button>
        </div>
        <div class="ml-2 undo-box">
          <button
            class="button is-ghost"
            @click="handleUndo"
            :disabled="!currentNumber"
          >
            <span class="icon has-text-info">
              <font-awesome-icon icon="undo-alt" />
            </span>
          </button>
        </div>
      </div>

      <div class="mt-1">
        <button class="button is-ghost ml-2" @click="mute(false)" v-if="muted">
          <span class="icon has-text-info">
            <font-awesome-icon icon="volume-mute" />
          </span>
        </button>
        <button
          class="button voice is-ghost ml-2 animate__heartBeat animate__infinite"
          @click="mute(true)"
          v-else
          :class="{ animate__animated: animateSpeach }"
        >
          <span class="icon has-text-info">
            <font-awesome-icon icon="volume-up" />
          </span>
        </button>

        <div class="is-inline-block mt-2">{{ currentSaying }}</div>
      </div>
    </div>
  </section>
  <div class="container">
    <Globe v-if="showGlobe" />
    <div class="glide" v-else>
      <div class="glide__track" data-glide-el="track">
        <ul class="glide__slides">
          <li class="glide__slide">
            <div class="number-sheet buttons is-centered">
              <FakeNumber />
              <Number
                v-for="number in numbersFirst"
                :key="number.value"
                :number="number"
                @number-called="handleNumberCalled"
                :fall="allCalled"
              ></Number>
            </div>
          </li>
          <li class="glide__slide">
            <div class="number-sheet buttons is-centered">
              <Number
                v-for="number in numbersSecond"
                :key="number.value"
                :number="number"
                @number-called="handleNumberCalled"
                :fall="allCalled"
              ></Number>
            </div>
          </li>
        </ul>
      </div>
      <div class="glide__bullets" data-glide-el="controls[nav]">
        <button class="glide__bullet" data-glide-dir="=0"></button>
        <button class="glide__bullet" data-glide-dir="=1"></button>
      </div>
    </div>
  </div>
  <section class="section">
    <div class="container">
      <div class="select is-info mt-3">
        <select v-model="selectedVoice" @change="handleVoiceChange">
          <option v-for="voice in voices" :value="voice.lang" :key="voice.lang">
            {{ voice.name }}
          </option>
        </select>
      </div>
      <font-awesome-icon icon="link" v-if="connected" class="ml-4 mt-5" />
    </div>
  </section>
</template>

<script>
import Number from './Number'
import FakeNumber from './FakeNumber'
import History from './History'
import Globe from '../pages/Globe'

import { load, save } from './game'
import {
  voices,
  announceNumber,
  speak,
  currentVoice,
  setVoice,
  muted,
  mute,
} from './announcer'

import Glide from '@glidejs/glide'
import Peer from 'peerjs'

const Game = {
  components: {
    Number,
    History,
    FakeNumber,
    Globe,
  },
  props: { id: String },
  data() {
    return {
      numbers: [],
      voices: [],
      selectedVoice: '',
      currentSaying: '',
      muted: false,
      animateSpeach: false,
      showGlobe: false,
      connected: false,
    }
  },
  computed: {
    history() {
      return this.numbers
        .filter(number => number.calledAt)
        .sort((a, b) => a.calledAt - b.calledAt)
    },
    currentNumber() {
      const lastNumbers = this.history
      return lastNumbers[lastNumbers.length - 1]
    },
    numbersFirst() {
      return this.numbers.slice(0, 45)
    },
    numbersSecond() {
      return this.numbers.slice(45)
    },
    allCalled() {
      console.log(this.history.length)
      return this.history.length > 89
    },
  },
  watch: {
    numbers: {
      deep: true,
      handler(numbers) {
        //console.log('saving numbers state', this.id, JSON.stringify(numbers))
        save(this.id, numbers)
        if (this.allCalled) {
          setTimeout(() => {
            this.showGlobe = true
          }, 5000)
        } else {
          this.showGlobe = false
        }
      },
    },
  },
  mounted() {
    const setVoices = () => {
      this.voices = voices()
      const theVoice = currentVoice()
      if (theVoice) this.selectedVoice = theVoice.lang
    }
    setVoices()
    if (speechSynthesis.onvoiceschanged !== undefined) {
      speechSynthesis.onvoiceschanged = setVoices
    }
    this.numbers = load(this.id)
    this.muted = muted()

    this.speak('Eyes down', this.selectedVoice)

    new Glide('.glide', { type: 'slider' }).mount()

    try {
      this.peer = new Peer('bingo-bango-' + this.id)
      this.peer.on('open', id => {
        console.log('My peer ID is: ' + id)
      })
      this.peer.on('error', error => {
        console.error(error)
      })

      this.peer.on('connection', conn => {
        console.log('incoming peer connection!')
        this.conn = conn
        this.connected = true
      })
      this.peer.on('disconnected', () => {
        this.conn = null
        this.connected = false
      })
    } catch (error) {
      console.log('No multi-play', error)
    }
  },
  unmmounted() {
    if (this.peer) this.peer.destroy()
  },
  methods: {
    sendToPlayers(number) {
      try {
        if (this.conn) this.conn.send(number)
      } catch (error) {
        console.log("Can't sent to other player", error)
      }
    },
    speak(phrase) {
      this.animateSpeach = true
      speak(phrase)
      setTimeout(() => (this.animateSpeach = false), 2000)
    },
    announce(number, voice) {
      this.animateSpeach = true
      setTimeout(() => (this.animateSpeach = false), 2000)
      this.sendToPlayers(number)
      return announceNumber(number, voice)
    },
    handleNumberCalled(number) {
      const saying = this.announce(number, this.selectedVoice)
      if (this.numbers[number - 1].calledAt) {
        if (this.currentNumber.value === number) {
          this.currentSaying = saying
        }
      } else {
        this.numbers[number - 1].calledAt = Date.now()
        this.currentSaying = saying
      }
    },
    handleVoiceChange(event) {
      setVoice(this.selectedVoice)
      this.speak(
        `Hi, I'm ${event.target.selectedOptions[0].innerText}. Nice to meet you, stinkers`,
        this.selectedVoice
      )
    },
    handleRecallCurrentNumber() {
      if (this.currentNumber) {
        this.currentSaying = this.announce(
          this.currentNumber.value,
          this.selectedVoice
        )
      }
    },
    handleUndo() {
      if (this.currentNumber) {
        this.speak(`Oops. Nope. Not ${this.currentNumber.value}.`)
        delete this.numbers[this.currentNumber.value - 1].calledAt
        this.currentSaying = ''
      }
    },
    mute(on) {
      on ? this.speak("OK. I'll shut up then.") : this.speak('Hai.')
      this.muted = on
      mute(on)
    },
  },
}

export default Game
</script>

<style scoped>
.history-box {
  text-align: right;
  flex-basis: 50%;
}

.undo-box {
  flex-basis: 50%;
}

.current-number {
  width: 8rem;
}

.current-number:focus {
  background-color: transparent !important;
}

.voice {
  background-color: transparent;
}

.section {
  padding: 1rem 1.5rem;
}

.is-ghost {
  border-color: transparent;
}

.glide__bullets {
  bottom: -1rem;
}
</style>
